module.exports = __webpack_public_path__ + "images/category_lp/hobby/assessment_achievements/6@2x_ec5e52620b2aeeece8662abfa8462641.png";